import { createContext, useContext } from "react";

interface WebSocketMethods {
  connect: (brand: string, role: string) => () => void;
  startNewConversation: (brand: string, role: string) => Promise<void>;
  submitQuestionToWebSocket: (prompt: string, brand: string, role: string) => Promise<void>;
  submitFeedback: (message_id: string, fedback: boolean) => Promise<void>;
  getConversationHistory: (brand: string, role: string) => Promise<void>;
  getConversationMssgs: (conversationId: string) => Promise<void>;
  stopWebSocketStream: () => void;
  transferToZendesk: (brand: string) => Promise<void>;
}

export const WebSocketContext = createContext<WebSocketMethods | null>(null);
export const useWebSocketContext = () => {
  const context = useContext(WebSocketContext);
  if (context === null) {
    throw new Error("WebSocket context is not available.");
  }
  return context;
};